import { render } from "./AddQuestionFlash.vue?vue&type=template&id=5257b4c2"
import script from "./AddQuestionFlash.vue?vue&type=script&lang=js"
export * from "./AddQuestionFlash.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__